var QawafilStoreFrontAuth = (function() {
    'use strict';

    var authModalEventsRegistered = false;

    /**
     * WS-WCA D5: show only the WhatsApp boxes / notice that the server names (`whatsapp_consent` of the verify answer:
     * per kind {show_box, show_notice}); every box starts empty. No answer = every part stays hidden.
     */
    function showWhatsappConsentParts(container, consent) {
        var $container = $(container);
        $container.find('.whatsapp-consent-box, .whatsapp-consent-notice').hide();
        $container.find('input[type="checkbox"]').prop('checked', false);
        if (!consent) {
            return;
        }
        $.each(consent, function (kind, parts) {
            if (parts && parts.show_box) {
                $container.find('.whatsapp-consent-box[data-kind="' + kind + '"]').show();
            }
            if (parts && parts.show_notice) {
                $container.find('.whatsapp-consent-notice[data-kind="' + kind + '"]').show();
            }
        });
    }

    function sessionLogin (accessToken, callback) {
        var body = {
            access_token: accessToken
        };

        fetch(Qawafil.getShopUrl() + '/token/login', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': Qawafil.auth_helpers.getAuthSessionToken()
            },
            body: JSON.stringify(body)
        })
            .then(response => response.json())
            .then(response => {
                if (typeof callback === 'function') {
                    callback(response);
                }
            })
            .catch(error => {
                console.error('Error:', error);
            });

        // $.ajax({
        //     url: shopEndpoint + '/token/login',
        //     type: 'POST',
        //     contentType: "application/json",
        //     headers: {
        //         'X-CSRF-TOKEN': AuthHelpers.getAuthSessionToken()
        //     },
        //     data: APIHelpers.jsonBody(body),
        //     success: function (response) {
        //         if (typeof callback === 'function') {
        //             callback(response)
        //         }
        //     }
        // });

    }

    function generateTokenViaSession (customerId, callback) {
        var body = {
            id: customerId
        };

        fetch(Qawafil.getShopUrl() + '/api-token/generate', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': Qawafil.auth_helpers.getAuthSessionToken()
            },
            body: JSON.stringify(body)
        })
            .then(response => response.json())
            .then(response => {
                if (typeof callback === 'function') {
                    callback(response);
                }
            })
            .catch(error => {
                console.error('Error:', error);
            });

        // $.ajax({
        //     url: shopEndpoint + '/api-token/generate',
        //     type: 'POST',
        //     contentType: "application/json",
        //     headers: {
        //         'X-CSRF-TOKEN': AuthHelpers.getAuthSessionToken()
        //     },
        //     data: APIHelpers.jsonBody(body),
        //     success: function (response) {
        //         if (typeof callback === 'function') {
        //             callback(response)
        //         }
        //     }
        // });

    }

    function syncSessionAndApiAuth () {
        var authSessionFound = Qawafil.auth_helpers.hasAuthSession();
        var apiAuthTokenFound = Qawafil.auth_helpers.hasApiAuthToken();
        consoleLog('auth .. init')
        consoleLog('hasAuthSession', authSessionFound)
        consoleLog('hasApiAuthToken', apiAuthTokenFound)

        if (!authSessionFound && apiAuthTokenFound) {
            consoleLog('auth .. init =====> if')
            Qawafil.auth_helpers.resetApiAuth();
        } else if (authSessionFound && !apiAuthTokenFound) {
            consoleLog('auth .. init =====> else ')
            // generate and store token using session
            generateTokenViaSession(Qawafil.auth_helpers.getAuthSessionCustomerId(), function (response) {
                if(response.data && response.data.user){
                    var accessToken = response.data.user.token;
                    if (accessToken) {
                        Qawafil.auth_helpers.setApiAuthToken(accessToken)
                        var locale = response.data.user.language ? response.data.user.language.code : null;
                        Qawafil.localization.setLocale(locale);
                    }
                }

            })
        }
    }

    function registerAuthModalsEvents(){
        var isSubmittingCode = false;

        var verify_count_down = document.getElementById('verify_count_down');
        var preventVerifyTime = 60;
        var verifyTimerId = null;
        var verify_count = 0;
        var resend_count_down = document.getElementById('resend_count_down');
        var timeLeft = 60;
        var timerId = null;

        var input2_mobile2 = TelMobile.init("#mobile2");
        var loginType = null;

        $("#email_btn").on('click',function () {
            loginType = 'email';
            $("#mobile_login_form").hide();
            $("#login_form").show();
            $("#mobile_btn").show();
            $("#or_use").show();
            $("#email_btn").hide();
            $("#verify_login_form").hide();
            $("#login_btn").show();
            $("#resend_email_code_btn").show();
            $("#resend_mobile_sms_code_btn").hide();
            $("#resend_mobile_whatsapp_code_btn").hide();
            $("#verify_login_form").trigger("reset");
            $(".msgs").html('');
            timeLeft = 60;
            $('#resend_email_code_btn').attr('disabled',true);
            $("#resend_mobile_sms_code_btn").attr('disabled',true);
            $("#resend_mobile_whatsapp_code_btn").attr('disabled',true);
            clearTimeout(timerId);
            $('#mobile2').val('');
        });
        $("#mobile_btn").on('click',function () {
            loginType = 'mobile';
            $('#login_email').val('');
            $("#mobile_login_btn").show();
            $("#mobile_msg_type_group").show();
            $("#mobile_login_form").show();
            $("#login_form").hide();
            $("#mobile_btn").hide();
            $("#email_btn").show();
            $("#or_use").show();
            $("#verify_login_form").hide();
            $("#resend_email_code_btn").hide();
            $("#resend_mobile_sms_code_btn").show();
            $("#resend_mobile_whatsapp_code_btn").show();
            $("#login_form").trigger("reset");
            $("#verify_login_form").trigger("reset");
            $(".msgs").html('');
            timeLeft = 60;
            $('#resend_email_code_btn').attr('disabled',true);
            $("#resend_mobile_sms_code_btn").attr('disabled',true);
            $("#resend_mobile_whatsapp_code_btn").attr('disabled',true);
            clearTimeout(timerId);
        });

        var startCodeResendTimer = function (){
            clearInterval(timerId);
            timeLeft = 60;
            timerId = setInterval(function() {
                if (timeLeft < 0) {
                    clearInterval(timerId);
                    // timeLeft = 60;
                    $('#resend_email_code_btn').attr('disabled',false);
                    $("#resend_mobile_sms_code_btn").attr('disabled',false);
                    $("#resend_mobile_whatsapp_code_btn").attr('disabled',false);
                    resend_count_down.innerHTML = '';

                } else {
                    resend_count_down.innerHTML =     'يمكنك إعادة إرسال رمز التحقق بعد: ' + timeLeft;
                    timeLeft--;
                }
            }, 1000);
        }

        var startPreventVerifyCountTimer = function() {
            $("#verify_btn").attr('disabled', true);
            clearInterval(verifyTimerId);
            preventVerifyTime = 60;
            verifyTimerId = setInterval(function() {
                if (preventVerifyTime < 0) {
                    clearInterval(verifyTimerId);
                    $("#verify_btn").attr('disabled', false);
                    verify_count_down.innerHTML = '';
                    verify_count = 0;

                } else {
                    verify_count_down.innerHTML = 'يمكنك إعادة التحقق بعد: ' + preventVerifyTime;
                    preventVerifyTime--;
                }
            }, 1000);
        }

        $("#login_form").submit(function (e) {
            e.preventDefault();

            $(".login_loading").show();
            $("#login_error").html('');
            let email = $("#login_form #login_email").val();
            if(!email) {
                toastError('يرجى ادخال البريد الإلكتروني');
                return;
            }
            Qawafil.auth.login({
                'verify_via': loginType,
                'email': email
            },function(response){
                if(response){
                    if (response.status && response.data.needed_action === 'email_verify_otp') {
                        $("#login_btn").hide();
                        $(".login_loading").hide();
                        $("#verify_login_form").show();
                        $("#login_verification_code").focus();
                        $("#padding_top").hide();
                        $("#result_msg_div").show();
                        $('#resend_email_code_btn').attr('disabled',true);
                        $(".msgs").html('');
                        if(response.message) $("#resend_msg").html(response.message);
                        if (response.message) toastSuccess(response.message);

                    } else {
                        // consoleLog('success else');
                        $(".login_loading").hide();
                        if (response.message && response.code !== 403) toastError(response.message);
                        QawafilStoreFront.helpers.showValidationErrors(response.errors);
                    }
                    if(response.data && response.data.error != 'max_send_count_exceeded'){
                        startCodeResendTimer()
                    }
                }else{
                    toastError();
                }

            });
        });

        $("#mobile_login_form").submit(function (e) {
            e.preventDefault();
            if (!isAllFormTelInputsAreValid(document.getElementById("mobile_login_form"))) {
                return false;
            }
            $(".login_loading").show();
            $("#login_error").html('');
            //mobile2
            // let mobile = $("#mobile_login_form #mobile2").val();
            let mobile = input2_mobile2.getNumber();
            let mobileMsgType = $("#mobile_login_form [name='mobile_msg_type']:checked").val();
            Qawafil.auth.login( {
                'verify_via': loginType + "_" + mobileMsgType,
                'mobile': mobile,
                // 'mobile_msg_type': mobileMsgType
            }, function(response){
                if(response){
                    if (response.status && response.data.needed_action === 'mobile_verify_otp') {
                        $("#mobile_login_btn").hide();
                        $("#mobile_msg_type_group").hide();
                        $(".login_loading").hide();
                        $("#verify_login_form").show();
                        $("#login_verification_code").focus();
                        $("#padding_top").hide();
                        // $("#mobile_result_msg").html(data.msg);
                        $("#resend_mobile_sms_code_btn").attr('disabled',true);
                        $("#resend_mobile_whatsapp_code_btn").attr('disabled',true);
                        $(".msgs").html('');
                        if(response.message) $("#resend_msg").html(response.message);
                        if(response.message) toastSuccess(response.message);
                    } else {
                        $(".login_loading").hide();
                        if(response.message && response.code !== 403) toastError(response.message);
                        QawafilStoreFront.helpers.showValidationErrors(response.errors);
                    }
                    if(response.data && response.data.error != 'max_send_count_exceeded'){
                        startCodeResendTimer()
                    }
                }else{
                    toastError();
                }
            });
        });

        $('#resend_email_code_btn').on('click',function () {
            $("#login_form").submit();
        });

        $('.resend_mobile_code_btn').on('click',function () {
            let msg_type = $(this).attr('data-msg-type');
            $(`[name="mobile_msg_type"][value="${msg_type}"]`).prop('checked', true)
            $("#mobile_login_form").submit();
        });

        $(document).on("keyup",'#login_verification_code',function (){
            if ($(this).val().length === 4 && !isSubmittingCode) {
                isSubmittingCode = true; // Set the flag to true
                $("#verify_login_form").submit();
            }
        });

        $("#verify_login_form").on('submit', function (e) {
            e.preventDefault(); // Prevent the default form submission
            // let mobile = $("#mobile_login_form #mobile2").val();
            if(verify_count > 2) return;

            var mobile = input2_mobile2.getNumber();
            if (mobile && loginType === 'mobile' && !isAllFormTelInputsAreValid(document.getElementById("mobile_login_form"))) {
                return false;
            }
            $('#verify_btn').attr('disabled',true);
            $(".login").attr('disabled', true);
            $(".login_loading").show();
            $("#login_error").html('');

            var verifyVia = loginType;
            if(loginType === 'mobile') verifyVia += ( "_" + $('[name="mobile_msg_type"]:checked').val());
            var verifyData = {
                'verify_via': verifyVia ,
                'code': $("#verify_login_form #login_verification_code").val(),
                'email': $("#login_form #login_email").val(),
                'mobile': mobile,
                // 'mobile_msg_type':  $('[name="mobile_msg_type"]:checked').val()
            }
            Qawafil.auth.verifyOTP(verifyData, function(response){
                isSubmittingCode = false; // Reset the flag after response
                if(response){
                    verify_count++;
                    if (response.status) {
                        $(".msgs").html('');
                        $("#login_modal").modal('hide');
                        if(response.data.verification_status === 'user-authenticated'){
                            let message = response.message;
                            let redirectUrl = response.data.redirect_url;
                            let accessToken = response.data.token;
                            let refreshToken = response.data.refresh_token;
                            let locale = response.data.user.language ? response.data.user.language.code : null;
                            sessionLogin(accessToken, function(response){
                                if(response.status){
                                    QawafilStoreFront.helpers.blockPage();
                                    Qawafil.localization.setLocale(locale);
                                    Qawafil.auth_helpers.setApiAuthToken(accessToken);
                                    Qawafil.auth_helpers.setApiRefreshToken(refreshToken);
                                    if(message) toastSuccess(message);
                                    window.location.reload();

                                }
                            });
                        }
                        else if(response.data.verification_status === 'user-initiated'){
                            $('#registration_code').val(response.data.registration_code);
                            $('#register_btn').html('تسجيل الدخول');
                            if(loginType === 'email') {
                                $("#register_form #register_email").val(verifyData.email)
                                $('#register_email_container').hide();
                            }
                            if(loginType === 'mobile') {
                                $("#register_form #register_mobile").val(verifyData.mobile)
                                $('#register_mobile_container').hide();
                            }
                            showWhatsappConsentParts('#signup_whatsapp_consent', response.data.whatsapp_consent);
                            $("#register_modal").modal('show');
                        }
                    }
                    else{
                        $(".login").attr('disabled', false);
                        $('#verify_btn').attr('disabled',false);
                        $(".login_loading").hide();
                        if(response.message && response.code !== 403) toastError(response.message);
                        if(verify_count > 2)
                        {
                            toastWarning('يجب عليك الانتظار لن تتمكن من التحقق لمدة 60 ثانية !!!');
                            startPreventVerifyCountTimer();
                        }
                    }
                }
                else{
                    toastError();
                }

            });
        });

        $("#register_form").submit(function (e) {
            e.preventDefault();
            $(".register").attr('disabled', true);
            $(".register_loading").show();

            let verifiedVia = loginType;
            if(loginType === 'mobile')  verifiedVia += ("_" + $('[name="mobile_msg_type"]:checked').val());

            var userData = {
                'verified_via': verifiedVia ,
                'registration_code':  $("#register_form #registration_code").val(),
                'email':  $("#register_form #register_email").val(),
                'first_name':  $("#register_form #register_first_name").val(),
                'last_name':  $("#register_form #register_last_name").val(),
                'mobile':  $("#register_form #register_mobile").val(),
            }
            // WS-WCA D5: a ticked WhatsApp box (the server writes a "yes" only for a box it asked to show).
            $('#signup_whatsapp_consent input[type="checkbox"]:checked').each(function () {
                userData[$(this).attr('name')] = 1;
            });

            if ( !userData.first_name || !userData.last_name){
                toastError('يرجى ادخال البيانات المطلوبة');
                return;
            }

            Qawafil.auth.register(userData, function(response){
                $(".register_loading").hide();
                $(".register").removeAttr('disabled');
                if(response){
                    if(response.status && response.data){
                        $("#register_modal").modal('hide');
                        var user = response.data.user;
                        var accessToken =  response.data.token;
                        var refreshToken =  response.data.refresh_token;
                        if (user && accessToken) {
                            // session login + store access token
                            var locale = user.language ? user.language.code : null;
                            var message = response.message;
                            sessionLogin(accessToken, function(response){
                                if(response.status){
                                    QawafilStoreFront.helpers.blockPage();
                                    Qawafil.localization.setLocale(locale);
                                    Qawafil.auth_helpers.setApiAuthToken(accessToken);
                                    Qawafil.auth_helpers.setApiRefreshToken(refreshToken);
                                    if(message) toastSuccess(message);
                                    window.location.reload();
                                }
                            });
                        }
                    }else{
                        if(response.message && response.code !== 403) toastError(response.message);
                        QawafilStoreFront.helpers.showValidationErrors(response.errors);
                    }
                }
                else{
                    toastError();
                }
            });
        });

    }

    function registerGeneralAuthEvents(){
        $('#btn-logout').on('click', function () {
            Qawafil.auth.logout(function (response) {
                if (response.status) {
                    Qawafil.auth_helpers.resetApiAuth();
                    window.location = Qawafil.getShopUrl() + '/logout'; // to remove user session
                }
            });
        });
        $('#login_modal').on('shown.bs.modal', function () {
            console.log("Modal is now shown.");
            if(!authModalEventsRegistered){
                registerAuthModalsEvents();
                authModalEventsRegistered = true;
            }
        });
    }


    function init(){
        syncSessionAndApiAuth();
        registerGeneralAuthEvents();
        // registerAuthModalsEvents();
    }

    return {
        init: init
    };

})();
